<template>
    <div>
		<v-row class="mb-1">
			<v-col cols="2" class="pe-0">
				<v-card height="185">
					<v-card-text style="height: 175px">
						<v-row align="center" style="height: 100%">
							<v-col class="d-flex justify-center pb-0" style="height: auto">
								<div class="">
									<!-- <v-img width="75" src="../../assets/OctopharmaLogo.png" /> -->
									<v-img 
										width="75" 
										src="../../assets/project.png"
									/>
								</div>
							</v-col>
							<v-col class="text-center" style="height: 100%" align-self="center">
								<h4 class="mb-1"> 
									{{ projectsBrief ? getProjectById($route.params.id)?.name : '-' }} 
								</h4>

								<p class="mb-0 pb-0"> Developer: 
									{{ 
										employeesCountInProject.length && employeesCountInProject.find(c => c.type === 'Developer') ? 
										employeesCountInProject.find(c => c.type === 'Developer')?.count :
											'-' 
									}} 
								</p>
								<p class=""> Administrative: 
									{{ 
										employeesCountInProject.length && employeesCountInProject.find(c => c.type === 'Administrative')? 	
										employeesCountInProject.find(c => c.type === 'Administrative')?.count : 
										'-' 
									}}  
								</p>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col md="7" cols="12">
				<!-- table -->
				<bee-handy-table
					:items="versions"
					:headers="headersVersion"
					:items-per-page="-1"
					:data-table-props="{
						disableSort: true,
						noDataText: ''
					}"
					fixed-header
					hide-default-footer
					dense
					zebra
					elevation="2"
					height="170"
					table-class="py-2 px-3 rounded-lg"
					:loading="loadingVersion || loading"
				></bee-handy-table>
			</v-col>

			<v-col md="3" cols="12" class="ps-0">
				<v-card>
					<v-card-text>
						<v-row>
							<v-col cols='12' sm="6" md="12" class="" align-self="start">
								<v-btn-toggle
									v-model="speacifice"
									mandatory
									dense
									class="d-flex justify-center rounded-lg"
									color="primary"
									style="width: 100%"
									:disabled="loadingAll"
								>
									<v-btn 
										:disabled="loading" 
										value="yearly" 
										class="text-none" 
										style="width: 50%"
									> 
										Yearly 
									</v-btn>
									<v-btn
										:disabled="loading"
										value="monthly"
										class="text-none"
										style="width: 50%"
									>
										Monthly
									</v-btn>
									<!-- <v-btn
										:disabled="loading"
										value="period"
										class="text-none"
										style="width: 33%"
									>
										Period 
									</v-btn> -->
								</v-btn-toggle>
							</v-col>

							<v-col
								v-if="speacifice !== 'period'"
								cols="12"
								align-self="start"
								:class="{
									'pt-0': $vuetify.breakpoint.mdAndUp
								}"
								class="d-flex align-center"
							>
								
								<v-autocomplete
									v-model="year"
									:items="years"
									item-text="name"
									item-value="name"
									hide-details='auto'
									label="Year"
									dense
									class="rounded-lg input"
									:disabled="loadingAll"
									solo
									:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
									append-icon=""
								/>
								<div class="d-flex flex-column">
									<v-btn icon x-small @click="addYear()" :disabled="!year || loadingAll">
										<v-icon small>
											mdi-menu-up
										</v-icon>									
									</v-btn>

									<v-btn
										icon
										x-small
										@click="subYear()"
										:disabled="(!year || years.indexOf(year) === 0) || loadingAll"
									>
										<v-icon small>
											mdi-menu-down
										</v-icon>									
									</v-btn>
								</div>
							</v-col>

							<v-col
								v-if="speacifice === 'monthly'"
								cols="12"
								align-self="start"
								class="d-flex align-center"
								:class="{
									'pt-0': $vuetify.breakpoint.mdAndUp
								}"
							>
								<v-autocomplete
									v-model="month"
									:items='months'
									item-text="name"
									item-value="value"
									label="Month"
									class="rounded-lg input"
									hide-details='auto'
									dense
									:disabled="!year || loadingAll"
									append-icon=""
									solo
									:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
								></v-autocomplete>
								<div class="d-flex flex-column">
									<v-btn icon x-small @click="addMonth()" :disabled="!month || loading">
										<v-icon small>
											mdi-menu-up
										</v-icon>									
									</v-btn>

									<v-btn
										icon
										x-small
										@click="subMonth()"
										:disabled="!month || months.indexOf(year) === 0 || loadingAll"
									>
										<v-icon small>
											mdi-menu-down
										</v-icon>									
									</v-btn>
								</div>
							</v-col>

							<v-col 
								v-if="speacifice === 'period'" 
								cols="12"
								:class="{
									'pt-0': $vuetify.breakpoint.mdAndUp
								}"
								class="px-0"
							>
								<bee-date-input
									v-model="fromDate"
									append-icon="mdi-menu-right"
									@click:append="upDayFrom(fromDate)"
									prepend-icon="mdi-menu-left"
									@click:prepend="downDayFrom()"
									label="Start date"
									input-format-order="DD-MM-YYYY"
									dense
									class="rounded-lg"
									hide-details
									:disabled="loadingAll"
								></bee-date-input>
							</v-col>

							<v-col
								v-if="speacifice === 'period'" 
								cols="12"
								:class="{
									'pt-0': $vuetify.breakpoint.mdAndUp
								}"	
								class="px-0"
							>
								<bee-date-input
									v-model="toDate"
									append-icon="mdi-menu-right"
									@click:append="upDayTo()"
									prepend-icon="mdi-menu-left"
									@click:prepend="downDayTo()"
									label="End date"
									input-format-order="DD-MM-YYYY"
									dense
									class="rounded-lg"
									hide-details
									:disabled="loadingAll"
								></bee-date-input>
							</v-col>

							<v-col class="pt-0 pb-1 px-0 d-flex justify-center">
								<v-btn
									color="dark-blue white--text"
									class="rounded-lg text-none mx-2"
									width="100%"
									@click="getAllStat()"
									:disabled="loadingAll || (speacifice === 'period' && !fromDate && !toDate)"
								>
									search
								</v-btn>
							</v-col>
						</v-row>

					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<!-- table -->
		<!-- :items="statsProjects.contributed_users.map(c => ({...c, status: 0 }))" -->
		<bee-handy-table
			:headers="headers"
			:items="statBasic"
			:items-per-page="-1"
			:data-table-props="{
				disableSort: true,
				noDataText: ''
			}"
			fixed-header
			hide-default-footer
			dense
			zebra	
			elevation="2"
			table-class="py-2 px-3 rounded-lg"
			:loading="loadingBasicStat || loading"
			:height="statBasic.length > 7 ? '250px' : 'auto'"
		>
			<template v-slot:item.hourCount="{ item }">
				<v-progress-linear :value="item.hourCount"></v-progress-linear>
			</template>

			<template v-slot:item.actions="{ item }">
				<!-- <v-btn
					color="edit-color"
					icon
					class="px-0"
					@click="projectId = item.id, dialog = true"
				>
					<v-icon> mdi-pencil </v-icon>
				</v-btn>

				<v-btn
					color="alert-color"
					icon
					class="px-0"
					@click="projectId = item.id, deleteDialog = true"
				>
					<v-icon> mdi-file-document-outline </v-icon>
				</v-btn> -->

				<v-switch
					v-model.number="item.status"
					label=""
					dense
					hide-details
					class="mt-0"
				></v-switch>
			</template>

			<!-- <v-template v-slot:item.status="{ item }">
				<v-switch
					v-model.number="item.status"
					label=""
					dense
					hide-details
					class="mt-0"
				></v-switch>
			</v-template> -->
		</bee-handy-table>
		
		<!-- Months & hour count  -->
		<v-row>
			<v-col cols="12" class="mt-3">
				<v-card       
					:max-height="$vuetify.breakpoint.height - 110"
					elevation="1"
					class="overflow-x-hidden rounded-lg"
					:class="{'pt-3': $vuetify.breakpoint.smAndDown}"
				>
					<v-card-text class="">
						<v-row>
							<v-col cols="auto" sm="6" md="7" class="d-flex align-end">
								<p class="my-0"> Months & hour count </p>
							</v-col>
						</v-row>
			
						<v-progress-linear
							v-if="loadingProjectWorkAverage"
							color="primary"
							indeterminate
						></v-progress-linear>
						<apexchart
							type="bar"
							height='250'
							width='90%'
							:options="!loadingProjectWorkAverage ? chartOptions : {}"
							:series="!loadingProjectWorkAverage ? seriesMonths : []"
						></apexchart>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

		<!-- Tags -->
		<v-row>
			<v-col cols="12" class="">
				<v-card 
					:max-height="$vuetify.breakpoint.height - 110"
					elevation="1"
					class="overflow-x-hidden rounded-lg"
					:class="{'pt-3': $vuetify.breakpoint.smAndDown}"
				>
					<v-card-text>
						<v-row>
							<v-col cols="auto" >
								<span class="my-0"> Tags </span>
							</v-col>
							<v-spacer />
							<v-col 
								cols="2" 
								class="d-flex align-end"
							>
								<v-autocomplete 
									v-model="tagId"
									:items="tags"
									item-text="name"
									item-value="id"
									solo
									:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
									dense
									filled
									label="Tag"
									class="input rounded-lg mb-1"
									hide-details
									@change="getProjectTags()"
									:disabled="loadingAll"
								/>
							</v-col>
						</v-row>
						<!-- {{ seriesTags }} 
						{{ tagsName }}
						<bar-chart
							type="bar"
							height='250'
							width='90%'
							:series='seriesTags'
							:categories="tagsName"
							class="my-3"
						></bar-chart> -->

						<v-progress-linear
							v-if="loadingTags"
							color="primary"
							indeterminate
						></v-progress-linear>
						<div style="width: 100%; height: 250">
							<apexchart
								type="bar"
								height='100%'
								width='90%'
								:options="!loadingTags ? chartOptionsTags : {}"
								:series="!loadingTags ? seriesTags : []"
							></apexchart>
						</div>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
    </div>
</template>

<script>
// import BarChart from '@/components/BarChart.vue'
import { mapGetters, mapState } from 'vuex'
import { userType } from '@/helper/enum'
import moment from 'moment'
export default {
	components: {
		// BarChart
	},
	data () {
		return {
			loading: false,
			tableInputs: {},

			// timelly: ['annually', 'monthly'],
			// items: [
			// 	{
			// 		totalTime: '217 h',
			// 		contributedUsers: 'Rola',
			// 		totalTask: '128'
			// 	},
			// 	{
			// 		totalTime: '400 h',
			// 		contributedUsers: 'Reem',
			// 		totalTask: '210'
			// 	}
			// ],
			speacifice: 'monthly',
	
			year: moment().year(),
			month: null,
			// projectVersion: [],
			statBasic: [],
			loadingBasicStat: false,
			loadingVersion: false,
			versions: [],
			loadingTags: false,
			tagsProjects: [],
			fromDate: moment().format('YYYY-MM-DD'),
			toDate: moment().format('YYYY-MM-DD'),
			months: [
				'January ',
				'February',
				'March',
				'April',
				'May',
				'June',
				'July',
				'August',
				'September',
				'October',
				'November',
				'December'
			],
			employeesCountInProject: [],
			userType,
			projectWorkAverage: [],
			loadingProjectWorkAverage: false,
			tagId: null
		}
	},
	computed: {
		loadingAll () {
			return this.loadingProjectWorkAverage || this.loadingBasicStat || this.loadingVersion || this.loading
		},
		years () {
			const years = []
			// get from create project
			const createdAt = '2020-10-10T10:10:29'
			const year = +(moment(createdAt).format('YYYY'))
			const yearNow = moment().year()
			for (let i = year; i <= yearNow; i++) {
				years.push(
					i
				)
			}
			return years
		},
		getFromDate () {
			const monthNumber = this.months.indexOf(this.month) + 1
			let fromDate = null
			if (this.speacifice === 'yearly') {
				fromDate = this.moment(this.moment((this.year).toString())).format('YYYY-MM-DD') 
			} else {
				if (this.speacifice === 'monthly') {
					fromDate = this.year + '-' + (
						monthNumber >= 10 ? monthNumber : '0' + monthNumber
					) + '-' + '01'
				} else {
					fromDate = this.fromDate
				}
			}
			return fromDate
		},
		getToDate () {
			const monthNumber = (this.months.indexOf(this.month) + 1).toString()
			let toDate = null
			if (this.speacifice === 'yearly') { 
				toDate = this.moment(this.moment((this.year).toString()).endOf('year')).format('YYYY-MM-DD') 
			} else {
				if (this.speacifice === 'monthly') {
					toDate = this.year + '-' + (
						monthNumber >= 10 
							? monthNumber 
							: '0' + monthNumber
					) + '-' + this.moment(this.moment(monthNumber).endOf('month')).format('DD')
				} else {
					toDate = this.toDate
				}
			}
			return toDate
		},
		headers () {
			const headers = [
				{
					text: 'Contributed users',
					name: 'userId',
					value: 'userId',
					setValueExpr: val => {
						const user = this.usersWithoutPag.find(c => c.id === val)?.employee
						return this.usersWithoutPag.find(c => c.id === val)?.employee.arabicFirstName + ' ' + this.usersWithoutPag.find(c => c.id === val)?.employee.arabicLastName
					} 
				},
				{
					text: 'Total time spent',
					name: 'durationInMinute',
					value: 'durationInMinute',
					setValueExpr: val => val > 0 ? (val / 60).toFixed(2) : 0
				},
				{
					text: 'Total Task',
					name: 'totalTask',
					value: 'totalTask'
				},
				{
					text: 'Role',
					name: 'roleId',
					value: 'roleId',
					setValueExpr: val => val ? this.getRoleById(val)?.name : null
				},
				{
					text: 'Hour count',
					name: 'contributedPercent',
					value: 'contributedPercent'
				},
				{
					text: 'Project entry date',
					name: 'entryDateTime',
					value: 'entryDateTime',
					setValueExpr: val => moment(val).format('YYYY-MM-DD')
				}
				// {
				// 	text: '',
				// 	name: 'actions',
				// 	value: 'actions',
				// 	noInput: true
				// }
			]
			return headers
		},
		headersVersion () {
			return [
				{
					text: 'Version',
					name: 'versionId',
					value: 'versionId',
					setValueExpr: val => this.getVersionById(val)?.name
				},
				{
					text: 'Hour count',
					name: 'durationInMinute',
					value: 'durationInMinute',
					setValueExpr: val => val > 0 ? (val / 60).toFixed(2) : 0 
				},
				{
					text: 'Tasks count',
					name: 'totalTask',
					value: 'totalTask'
				}
			]
		},
		...mapState({
			statsProjects: state => state.projects.statsProjects,
			usersWithoutPag: state => state.users.usersWithoutPag,
			rolesInProject: state => state.rolesInProject.rolesInProject,
			allVersions: state => state.projectVersion.allVersions,
			tags: state => state.tags.tags,
			projectsBrief: state => state.projects.projectsBrief
		}),

		...mapGetters({
			getRoleById: 'rolesInProject/getRoleById',
			getVersionById: 'projectVersion/getVersionById',
			getTagById: 'tags/getTagById',
			getProjectById: 'projects/getProjectById'
		}),

		tagsName () {
			if (this.tagsProjects.length) {
				return this.tagsProjects?.map(c => this.getTagById(c.tagId)?.name)
			} else {
				return []
			}
		},
		
		seriesTags () {		
			return [
				{
					name: 'Inf',
					data: this.tagsProjects.length ? this.tagsProjects?.map(c => (c.spentTime / 60).toFixed(2)) : []
				}
			]
		},

		chartOptions () {
			return {
				chart: {
					type: 'bar'
				},
				plotOptions: {
					bar: {
						borderRadius: 5,
						dataLabels: {
							position: 'top'
						}
					}
				},
				dataLabels: {
					enabled: true,
					formatter: function (val) {
						return val
					},
					offsetY: 10,
					style: {
						fontSize: '12px'
					}
				},
				yaxis: {
					labels: {
						show: true
					}
				},
				markers: {
					size: 5
				},
				xaxis: {
					type: 'category',
					categories: this.projectWorkAverage?.map(c => this.speacifice === 'monthly' ? moment(c.date).format('DD') : moment(c.date).format('MM'))
				},
				tooltip: {
					enabled: false
				},
				grid: {
					show: true
				},
				theme: {
					mode: this.$vuetify.theme.dark ? 'dark' : 'light'
				}
			}
		},
		seriesMonths () {
			return [
				{
					name: 'inf',
					data: this.projectWorkAverage?.map(c => (c.workTime / 60).toFixed(2))
				}
			]
		},

		chartOptionsTags () {
			return {
				chart: {
					type: 'bar'
				},
				plotOptions: {
					bar: {
						borderRadius: 5,
						dataLabels: {
							position: 'top'
						}
					}
				},
				dataLabels: {
					enabled: true,
					formatter: function (val) {
						return val
					},
					offsetY: 10,
					style: {
						fontSize: '12px'
					}
				},
				yaxis: {
					labels: {
						show: true
					}
				},
				markers: {
					size: 5
				},
				xaxis: {
					type: 'category',
					categories: this.tagsName
				},
				tooltip: {
					enabled: false
				},
				grid: {
					show: true
				},
				theme: {
					mode: this.$vuetify.theme.dark ? 'dark' : 'light'
				}
			}
		}
	},

	methods: {
		moment,
		addYear () {
			this.year = this.years[this.years.indexOf(this.year) + 1]
		},
		subYear () {
			this.year = this.years[this.years.indexOf(this.year) - 1]
		},
		addMonth () {
			this.month = this.months[this.months.indexOf(this.month) + 1]
		},
		subMonth () {
			this.month = this.months[this.months.indexOf(this.month) - 1]
		},
		upDayFrom () {
			this.fromDate = moment(this.fromDate).add(1, 'day').format('YYYY-MM-DD')
			return this.fromDate
		},
	
		downDayFrom () {
			this.fromDate = moment(this.fromDate).subtract(1, 'day').format('YYYY-MM-DD')
			return this.fromDate
		},

		upDayTo () {
			this.toDate = moment(this.toDate).add(1, 'day').format('YYYY-MM-DD')
			return this.toDate
		},
	
		downDayTo () {
			this.toDate = moment(this.toDate).subtract(1, 'day').format('YYYY-MM-DD')
			return this.toDate
		},
		getBasicStat () {
			this.loadingBasicStat = true
			const monthNumber = this.months.indexOf(this.month) + 1
			this.$store.dispatch('projectStatistics/fetchBasicStat', { 
				projectId: this.$route.params.id,
				fromDate: this.getFromDate,
				toDate: this.getToDate
			}).then((data) => {
				this.statBasic = data
			}).finally(() => {
				this.loadingBasicStat = false
			})
		},

		getVersions () {
			this.loadingVersion = true
			this.$store.dispatch('projectStatistics/fetchVersion', { 
				projectId: this.$route.params.id
			}).then((data) => {
				this.versions = data
			}).finally(() => {
				this.loadingVersion = false
			})
		},

		getProjectTags () {
			this.loadingTags = true
			this.$store.dispatch('projectStatistics/fetchTagProject', { 
				projectId: this.$route.params.id,
				tagId: this.tagId,
				fromDate: this.getFromDate,
				toDate: this.getToDate,
				annualy: this.speacifice === 'yearly',
				withoutDuplicate: true
			}).then((data) => {
				this.tagsProjects = data
			}).finally(() => {
				this.loadingTags = false
			})
		},

		getProjectWorkAverage () {
			this.loadingProjectWorkAverage = true
			return this.$store.dispatch('projectStatistics/fetchProjectWorkAverage', {
				projectId: this.$route.params.id,
				fromDate: this.getFromDate,
				toDate: this.getToDate,
				annualy: this.speacifice === 'yearly',
				withEmptyDates: true
			}).then((data) => {
				this.projectWorkAverage = data
			}).finally(() => {
				this.loadingProjectWorkAverage = false
			})
		},

		getAllStat () {
			this.getBasicStat()
			this.getVersions()
			this.getProjectWorkAverage()
			this.getProjectTags()
			// if (this.speacifice !== 'yearly') {
			// } 
		}
	},

	mounted () {
		this.month = this.months[moment().month()]
	},
	created () {
		this.month = this.months[moment().month()]
		this.year = moment().year()
		this.loading = true
		Promise.all([
			!this.usersWithoutPag.length ? this.$store.dispatch('users/fetchUsersWithoutPag', { isActiveOnly: false }) : null,
			!this.rolesInProject.length ? this.$store.dispatch('rolesInProject/fetchAll') : null,
			this.$store.dispatch('projectVersion/fetchAll'),
			!this.tags.length ? this.$store.dispatch('tags/fetchAll') : null,
			!this.projectsBrief.length ? this.$store.dispatch('projects/fetchProjectBrief') : null
		]).then(() => {
			// for table
			this.getBasicStat()
			// for version
			this.getVersions()
			// for tags
			this.getProjectTags()
			this.getProjectWorkAverage()
			this.$store.dispatch('projectStatistics/fetchEmployeeTypeCountInProject', { projectId: this.$route.params.id }).then((data) => {	
				this.employeesCountInProject = data.map(c => ({ 
					type: c.userType === userType.Developer ? 'Developer' : 'Administrative',
					count: c.userType === userType.Developer 
						? c.typesCount 
						: data?.filter(d => d.userType !== userType.Developer).length > 1 
							? data?.filter(c => c.userType !== userType.Developer)?.reduce((a, b) => a.typesCount + b.typesCount) 
							: data?.filter(c => c.userType !== userType.Developer)[0]?.typesCount 
				}))
			})
		}).finally(() => {
			this.loading = false
		})
	}
}
</script>
